import { render } from "./LaptopsModule.vue?vue&type=template&id=df0d03a4&scoped=true"
import script from "./LaptopsModule.vue?vue&type=script&lang=js"
export * from "./LaptopsModule.vue?vue&type=script&lang=js"

import "./LaptopsModule.vue?vue&type=style&index=0&id=df0d03a4&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-df0d03a4"

export default script